import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { UserInfoService } from 'fines-portal/shared/api/data-access/user-info';
import { RouterService } from 'fines-portal/shared/router/data-access/router';
import { map } from 'rxjs';
import { LogService } from 'shared/core/data-access/log';

export const authenticatedGuard = (() => {
    const userInfoService = inject(UserInfoService);
    const routerService = inject(RouterService);
    const logService = inject(LogService);

    logService.log('Trying to access authenticated section');
    return userInfoService.getUserInfo().pipe(
        map((userInfo) => {
            if (userInfo) {
                logService.log('User is logged in -> allow');
                return true;
            } else {
                logService.log(
                    'User is not logged in -> redirect to login page',
                );
                routerService.login().goTo();
                return false;
            }
        }),
    );
}) satisfies CanMatchFn;
